import {fetchApi} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'
import * as types from './types'
import formatWeatherUrlQueries from '../utils/formatWeatherUrlQueries'
import moment from 'moment'
import config from 'config/applicationConfig'

export default (params) => dispatch => {
    dispatch({type: types.GET_WEATHER_START})
    dispatch(resetError())
    params.begin = moment().utc().add(config.weatherOffset.minus, config.weatherOffset.type).toISOString()
    params.end = moment().utc().add(config.weatherOffset.plus, config.weatherOffset.type).toISOString()
    const urls = formatWeatherUrlQueries(params)
    return Promise.all(urls.map((url) => fetchApi(url)))
        .then(responses => Promise.all(responses.map((response) => response.json())))
        .then(responses => {
            dispatch({
                type: types.GET_WEATHER_SUCCESS, responses: responses
            })
        }).catch(error => {
            dispatch({
                type: types.GET_WEATHER_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading weather.'}))
        })
}

export const handler_GET_WEATHER_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true,
        data: undefined
    })
}

export const handler_GET_WEATHER_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: action.responses
    })
}

export const handler_GET_WEATHER_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.GET_WEATHER_START] = handler_GET_WEATHER_START
actionMap[types.GET_WEATHER_SUCCESS] = handler_GET_WEATHER_SUCCESS
actionMap[types.GET_WEATHER_FAILURE] = handler_GET_WEATHER_FAILURE


// WEBPACK FOOTER //
// ./src/screens/weather/actions/getWeather.js